import {h, Fragment} from "preact"
const RadioFacet = ({ facet, facetOptions, searchFilters }) => {
  const togglePreferredSeller = (value, field, e) => {
    e.preventDefault();
    searchFilters({ ...value, field: field });
  };

  return facetOptions.map((facetValue, loopIndex) => {
    return (
      facetValue.value.toLowerCase() === "preferred seller" && (
        <div className="py-2 lg:p-2 flex flex-row gap-2 items-center cj-best">
          <div className="flex flex-row items-center gap-1">
            <svg
              width="16"
              height="16"
              className="m-auto"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.219971"
                width="16"
                height="16"
                rx="8"
                fill="#606BFA"
              />
              <path
                d="M11.5 6.21997L7.5 10.22L5.5 8.21997"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span className="purple-seller"> {facetValue.value}</span>
          </div>
          <label class="switch">
            <input
              type="checkbox"
              id={`filter-${facet.field}-${loopIndex}`}
              name={facet.field}
              checked={facetValue.selected}
              onChange={(e) => {
                togglePreferredSeller(facetValue, facet.field, e);
              }}
            />
            <span class="slider round"></span>
          </label>
        </div>
      )
    );
  });
};

export default RadioFacet;
